(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('SurveyResult', SurveyResult);

    SurveyResult.$inject = ['$resource', 'DateUtils'];

    function SurveyResult ($resource, DateUtils) {
        var resourceUrl =  'api/survey-results/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                    data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
